import { useCallback, useMemo, useState } from "react";
import { SxProps, Theme } from "@mui/material/styles";

const EDITING_CONTAINER_SX: SxProps<Theme> = {
    display: "flex",
    flex: 1,
    minHeight: 0,
};

interface UseMarkdownEditScrollLockResult {
    isMarkdownEditing: boolean;
    onMarkdownEditingChange: (isEditing: boolean) => void;
    markdownEditingContainerSx: SxProps<Theme> | undefined;
}

export default function useMarkdownEditScrollLock(): UseMarkdownEditScrollLockResult {
    const [activeEditors, setActiveEditors] = useState(0);

    const onMarkdownEditingChange = useCallback((isEditing: boolean) => {
        setActiveEditors((currentCount) => {
            const nextCount = currentCount + (isEditing ? 1 : -1);
            return nextCount < 0 ? 0 : nextCount;
        });
    }, []);

    const isMarkdownEditing = activeEditors > 0;

    const markdownEditingContainerSx = useMemo(
        () => (isMarkdownEditing ? EDITING_CONTAINER_SX : undefined),
        [isMarkdownEditing]
    );

    return {
        isMarkdownEditing,
        onMarkdownEditingChange,
        markdownEditingContainerSx,
    };
}
